const snapchatFullscreenBtn = document.querySelectorAll('.snapchat-player-fullscreen-trigger');
const snapchatOpenBtn = document.querySelectorAll('.js-open-snapchat-player');
const snapchatCloseBtn = document.querySelectorAll('.snapchat-player-close-btn');
if(snapchatFullscreenBtn){
    snapchatFullscreenBtn.forEach(button=>{
        button.addEventListener('click', function (){
            const playerWrapper = this.closest('.snapchat-player-wrapper');
            const player = playerWrapper.querySelector('.snapchat-player');
            if(playerWrapper.classList.contains('open-fullscreen')){
                playerWrapper.classList.remove('open-fullscreen');
                document.body.classList.remove('disable-scroll');
                if(document.querySelector('.tvg_product_gallery_THC9AW_ProductGallery')){
                    document.querySelector('.tvg_product_gallery_THC9AW_ProductGallery').removeAttribute('style')
                }
                if(player){
                    window.sendLensSize((player.offsetWidth*1.5), (player.offsetHeight*1.5))
                }
            }else{
                playerWrapper.classList.add('open-fullscreen');
                document.body.classList.add('disable-scroll');
                if(document.querySelector('.tvg_product_gallery_THC9AW_ProductGallery')){
                    document.querySelector('.tvg_product_gallery_THC9AW_ProductGallery').style.zIndex = '10000'
                }
                if(player){
                    window.sendLensSize((player.offsetWidth*1.5), (player.offsetHeight*1.5))
                }
            }
        })
    })

}
if(snapchatOpenBtn){
    snapchatOpenBtn.forEach(function (button){
        button.addEventListener('click',function (){
            openSnapchatPlayer();
        })
    })
}
if(snapchatCloseBtn){
    snapchatCloseBtn.forEach(function (button){
        button.addEventListener('click',function (){
            if(document.querySelector('.snapchat-player-wrapper')){
                document.querySelector('.snapchat-player-wrapper').classList.remove('open');
                document.querySelector('.snapchat-player-wrapper').classList.remove('open-fullscreen');
                 document.body.classList.remove('disable-scroll');
                stopCameraStream();
                if(document.querySelector('.js-mobile-product-gallery')){
                	document.querySelector('.js-mobile-product-gallery').removeAttribute('style');
                }
            }
        })
    })
}
if(window.matchMedia('(max-width:639px)').matches){
    if(document.querySelector('.js-snapchat-desktop-player')){
        document.querySelector('.js-snapchat-desktop-player').remove();
    }
}else{
    if(document.querySelector('.js-snapchat-mobile-player')){
        document.querySelector('.js-snapchat-mobile-player').remove();
    }
}

function openSnapchatPlayer(){
    if(document.querySelector('.snapchat-player-wrapper') && document.querySelector('.snapchat-player') && document.querySelector('input[name="id"]')){
        const lensId = getLensId(parseInt(document.querySelector('input[name="id"]').value));
        const player = document.querySelector('.snapchat-player');
        if(lensId &&  lensId != 'none'){
            console.log(lensId, player.offsetWidth, player.offsetHeight)
            window.sendInputToLens(lensId, (player.offsetWidth*1.5), (player.offsetHeight*1.5))
            window.sendLensSize((player.offsetWidth*1.5), (player.offsetHeight*1.5))
        }
        document.querySelector('.snapchat-player-wrapper').classList.add('open');
        if(document.querySelector('.js-mobile-product-gallery')){
        	document.querySelector('.js-mobile-product-gallery').style.visibility = 'hidden';
        }
    }
}
function lensVariantChange(variant){
    const lensId = getLensId(variant.id)
    if(document.querySelector('.snapchat-player-wrapper.open') && lensId &&  lensId != 'none'){
        window.sendInputToLens(lensId)
    }
}
function getLensId(variantId){
    if(document.querySelector('[data-lens-id]')){
        const lensIdJson = JSON.parse(document.querySelector('[data-lens-id]').textContent)
        const currentVariant = lensIdJson.find(item=> item.id == variantId);
        if(currentVariant){
            return currentVariant.lensId
        }
    }else{
        return false
    }
}
